import { RTypeRadiateurSchema_Type } from '@batical/types/src'
import { fetchGeneric, fetchGenericSorted } from './GenericQ'

const RTypeRadiateur: Array<RTypeRadiateurSchema_Type> = require('../json/RRadiateur.json')

export function fetchTypeRadiateurSorted(type: number): Array<{ value: string; label: string }> {
  const condition = type === 0 ? 'Acier' : type === 2 ? 'Aluminium' : ''
  return fetchGenericSorted(RTypeRadiateur.filter((item: RTypeRadiateurSchema_Type) => item.type === condition))
}

export function fetchTypeRadiateur(uuid: string): RTypeRadiateurSchema_Type {
  return fetchGeneric(RTypeRadiateur, uuid)
}
